module.exports = __webpack_public_path__ + "static/media/auth_confirm.3debd207.jpg";